import { render } from "./AcceptedDiscarded.vue?vue&type=template&id=c0f997b2"
import script from "./AcceptedDiscarded.vue?vue&type=script&lang=js"
export * from "./AcceptedDiscarded.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__